/**
 * NullGpuTimer — no-op fallback when neither WebGPU timestamp-query
 * nor EXT_disjoint_timer_query_webgl2 is available.
 *
 * All methods are safe to call unconditionally; none stall the GPU.
 */
import type { IGpuTimerBackend } from './GpuTimerBackend.js';

const EMPTY: ReadonlyMap<string, number> = new Map();

export class NullGpuTimer implements IGpuTimerBackend {
  readonly available = false;

  beginPass(_name: string): void {
    // no-op
  }

  endPass(_name: string): void {
    // no-op
  }

  endFrame(): void {
    // no-op
  }

  readFrame(): ReadonlyMap<string, number> {
    return EMPTY;
  }

  dispose(): void {
    // no-op
  }
}
